import { CorrespondenceChecker } from 'product_modules/utils/valueVisualTypeCorrespondenceCheckers/Types';
import { VariableValue } from 'product_modules/api/Types';

const isCorrespondsText: CorrespondenceChecker<string> = (value: VariableValue): value is string => {
  return typeof value === 'string';
};

export default isCorrespondsText;
